import { type UnderlyingSymbol } from "#/types/markets";

export interface AccountRiskStatusValues {
  mmr: number;
  isLiquidated: boolean;
}

export type AccountRiskStatus = Partial<
  Record<UnderlyingSymbol, AccountRiskStatusValues>
>;

export enum LiquidationWarningStatus {
  Inactive = "inactive",
  Active = "active",
  Dismissed = "dismissed",
}

export type LiquidationWarningThresholds = Record<
  string /* threshold */,
  LiquidationWarningStatus
>;

export type LiquidationWarnings = Partial<
  Record<UnderlyingSymbol, LiquidationWarningThresholds>
>;

export type LiquidationWarningVariant = "warning" | "liquidation";

export interface LiquidationWarningDetails {
  symbol: UnderlyingSymbol;
  variant: LiquidationWarningVariant | "none";
  mmr: number;
}
